<template>
    <div class="borderPink" v-if="cmReceivedQuotes.length">
        <div @click="showCMReceived = !showCMReceived" class="cmReceived" v-if="cmReceivedQuotes.length">CM Received</div>
        <v-data-table hide-actions v-if="showCMReceived && cmReceivedQuotes.length" :headers="headers" :items="cmReceivedQuotes" :loading="quoteLoading">
          <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <td v-if="editDeleteAllowed"><v-btn small flat color="primary" target="_blank" :to="`/quotes/edit/${props.item._id}`">{{ props.item.orderCode }}</v-btn></td>
            <td v-else>{{ props.item.orderCode }}</td>
            <td v-if="props.item.customerID">{{ props.item.customerID.firstName }} {{ props.item.customerID.lastName}}</td>
            <td v-else>N/A</td>
            <td v-if="props.item.updatedBy">{{props.item.updatedBy.firstName}}</td>
            <td v-else-if="props.item.createdBy">{{props.item.createdBy.firstName}}</td>
            <td>${{ props.item.subTotal.toFixed(2) }}</td>
            <td>{{ new Date(props.item.date).getDate() + "/" + (new Date(props.item.date).getMonth() + 1) + "/" + new Date(props.item.date).getFullYear() }}</td>
            <td>
              <v-select @change="quoteActions" :items="actionItems(props)" label="Actions"></v-select>
            </td>
          </template>
          <template slot="no-data">
            {{ loadingText }}
          </template>
          <template slot="no-results">
            Your search for '{{ search }}' didn't return any results.
          </template>
        </v-data-table>
    </div>
</template>

<script>
import OrderService from '@/services/OrderService'
import _ from 'lodash'

export default {
  data: () => ({
    loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
    editDeleteAllowed: true,
    showCMReceived: false,
    cmReceivedQuotes: [],
    headers: [
      { text: 'Order Code', value: 'orderCode' },
      { text: 'Customer Name', value: 'customerName' },
      { text: 'User', value: 'User' },
      { text: 'Total', value: 'total' },
      { text: 'Date', value: 'date' },
      { text: 'Actions', value: 'actions' }
    ]
  }),
  mounted () {
    if (localStorage.getItem('is_admin') === 'true') {
      this.editDeleteAllowed = false
    } else {
      this.editDeleteAllowed = true
    }
    this.getCMReceivedQuotes()
    console.log(this.loggedInUser)
  },
  methods: {
    async getCMReceivedQuotes () {
      // cmReceivedQuotes
      const response = await OrderService.getCMReceivedQuotes(this.loggedInUser._id)
      this.cmReceivedQuotes = response.data.orders
    },
    actionItems (props) {
      let returnArray = []
      returnArray.push({text: 'Archive', value: {action: 'archive', id: props.item._id}})
      returnArray.push({text: 'Duplicate', value: {action: 'duplicate', id: props.item._id}})
      if (props.item.install > 0) {
        returnArray.push({text: 'CM Required', value: {action: 'cmRequired', id: props.item._id, installationNotes: props.item.installationNotes, index: props.index}})
      }
      returnArray.push({text: 'Email Quote', value: {action: 'email', id: props.item._id}})
      returnArray.push({text: 'Download Quote', value: {action: 'pdf', id: props.item._id, orderCode: props.item.orderCode}})
      returnArray.push({text: 'Download Invoice', value: {action: 'pdfInvoice', id: props.item._id, orderCode: props.item.orderCode}})
      returnArray.push({text: 'Download Pretty Quote', value: {action: 'pretty', id: props.item._id, orderCode: props.item.orderCode}})
      if (props.item.checkCMExist) {
        returnArray.push({text: 'Download CM', value: {action: 'CM', id: props.item._id, orderCode: props.item.orderCode, CMImg: props.item.checkMeasureImg}})
      }
      returnArray.push({text: 'Process Order', value: {action: 'checkPayment', id: props.item._id, item: props.item, index: props.index}})
      return returnArray
    },
    async quoteActions (value) {
      switch (value.action) {
        case 'archive':
          await OrderService.updateOrderStatus(value.id, 'Archived')
          this.getQuotes()
          break
        case 'duplicate':
          const duplicateResponse = await OrderService.duplicateOrder(value.id)
          if (duplicateResponse.data.success) {
            this.popupText = `Quote duplicated successfully. Quote ${duplicateResponse.data.order.orderCode} created.`
            this.snackbar = true
          }
          this.quotes = await this.getQuotes()
          break
        case 'email':
          const emailResponse = await OrderService.emailQuote(value.id)
          if (emailResponse.data.success) {
            this.popupText = 'Email sent successfully.'
            this.snackbar = true
          }
          break
        case 'pdf':
          this.pdfQuote(value.id, value.orderCode)
          break
        case 'pdfInvoice':
          this.pdfInvoice(value.id, value.orderCode)
          break
        case 'pretty':
          this.prettyQuote(value.id, value.orderCode)
          break
        case 'CM':
          this.CMs = []
          let vm = this
          _.forEach(value.CMImg, item => {
            var exist = false
            this.checkMeasureImgExistOrNot(item).then(function (val) {
              exist = val
              let obj = {file: item, exist: exist}
              vm.CMs.push(obj)
            })
          })
          this.dialog = true
          break
        case 'order':
          const orderResponse = await OrderService.upgradeQuote(value.id)
          if (orderResponse.data.success) {
            this.popupText = 'Quote upgraded successfully.'
            this.snackbar = true
            this.getQuotes()
          }
          break
        case 'cmRequired':
          this.selectedIndex = value.index
          this.cmRequiredDialog = true
          break
        case 'checkPayment':
          this.selectedIndex = value.index
          this.paymentDialog = true
          break
      }
    }
  }
}
</script>

<style>
.cmReceived {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  cursor: pointer;
  color: #ea4d76;
}
.borderPink {
  border: 2px solid #ea4d76;;
}
</style>



// WEBPACK FOOTER //
// src/components/CMReceived.vue